import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ellipses',
  standalone: true,
})
export class EllipsesPipe implements PipeTransform {
  transform(val: any) {
    return val.substring(0, Math.min(50, val.length)) + '...';
  }
}
